/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Integration provider identifier.
 */
export enum IntegrationProviderId {
    MELI = 'meli',
    _2CLICS = '2clics',
    WASI = 'wasi',
    TOPPROPIEDADES = 'toppropiedades',
    KITEPROP = 'kiteprop',
}
